import { Fieldset, Stack, Title } from '@mantine/core';
import { useFormContext } from '../../contexts/formContext';
import { OnOffSetting } from '../../components/OnOffSetting';
import { RemoveSmallGeometry } from './settings/RemoveSmallGeometry';

const path = 'sceneManipulation';

export function SceneManipulationOperation() {
  const form = useFormContext();

  return (
    <Stack align='flex-start' mb='lg'>
      <Title order={5}>Scene Manipulation</Title>
      <Fieldset disabled={false} variant='unstyled'>
        <Stack gap='xl'>
          <OnOffSetting
            onChanged={(option) => form.setFieldValue(`${path}.removeInvisibleGeometry`, option)}
            initialOption={form.values.sceneManipulation?.removeInvisibleGeometry ?? false}
            title='Remove Invisible'
            description='Select if invisible geometry (inside the mesh) should be removed'
          />
          <RemoveSmallGeometry />
          <OnOffSetting
            onChanged={(option) => form.setFieldValue(`${path}.discardAnimations`, option)}
            initialOption={form.values.sceneManipulation?.discardAnimations ?? false}
            title='Discard Animations'
            description='Specify if animations should be discarded before optimization. If your model contains animations and this is set to false, the model will not be optimized.'
          />
          <OnOffSetting
            onChanged={(option) => form.setFieldValue(`${path}.rotateZUp`, option)}
            initialOption={form.values.sceneManipulation?.rotateZUp ?? false}
            title='Rotate Z Up'
            description='Specify if rotation to z-axis pointing upwards'
          />
          <OnOffSetting
            onChanged={(option) => form.setFieldValue(`${path}.centerModel`, option)}
            initialOption={form.values.sceneManipulation?.centerModel ?? false}
            title='Center Model'
            description='Centers the model around the coordinate origin before export'
          />
        </Stack>
      </Fieldset>
    </Stack>
  );
}
